import Component from '../app/component';

export default class extends Component {
  constructor(el) {
    super(el);
    this.data = {};
  }
}
